import React, { useEffect, useState } from "react";
import Table from "../../components/Tabla/Table";
import Api from "../../utils/services/Api";
import EndPoints from "../../utils/services/EndPoints";
import { getCodigoIfip } from "../../utils/Common";
import { useSnackbar } from "notistack";

const ListSocio = ({ onSocioClick }) => {
  const [loading, setLoading] = useState(true);
  const [listPersonas, setListPersonas] = useState([])
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    // we have to keep track if our component is mounted
    let isMounted = true

    const fetchData = async () => {
      Api(EndPoints.listadoSocio + "/" + getCodigoIfip(), "GET", null)
        .then((response) => {
          if (isMounted) {
            setListPersonas(response);
            setLoading(false);
          }
        })
        .catch((error) => {
          enqueueSnackbar(error.message, { variant: "error" })
        });
    }

    fetchData();

    // the cleanup function toggles the variable where we keep track
    // if the component is mounted
    // note that this doesn't cancel the fetch request
    // it only hinders the app from setting state (see above)
    return () => {
      isMounted = false
    }
  }, []);

  return (
    <Table
      id="lista-socios"
      title=""
      columns={[
        {
          title: "CODIGO",
          field: "codigo",
          width: 5
        },
        {
          title: "IDENTIFICACION",
          field: "personaMs.numeroIdentificacion",
          width: 10,
        },
        {
          title: "NOMBRES",
          field: "personaMs.nombres",
          width: 150,
        },
        {
          title: "CORREO",
          field: "personaMs.correoElectronico",
          width: 150,
        },
      ]}
      data={listPersonas}
      onRowClick={(evt, selectedRow) => onSocioClick(selectedRow)}
      loading={loading}
    />
  );
};

export default ListSocio;